"use strict";

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var network_1 = require("./network");

var Token;

(function (Token) {
  Token[Token["ETH"] = 0] = "ETH";
  Token[Token["USDC"] = 1] = "USDC";
  Token[Token["DAI"] = 2] = "DAI";
})(Token = exports.Token || (exports.Token = {}));

var ETHER_TOKEN_ADDRESS = "0x0000000000000000000000000000000000000001";
var tokenToAddressMap = new Map([[network_1.Network.Mainnet, new Map([[Token.ETH, ETHER_TOKEN_ADDRESS], [Token.USDC, "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"], [Token.DAI, "0x6b175474e89094c44da98b954eedeac495271d0f"]])], [network_1.Network.Ropsten, new Map([[Token.ETH, ETHER_TOKEN_ADDRESS], [Token.USDC, "0xED56B9F64cC1df8F0A2Eeb444d3a1eb7DFa1D047"], [Token.DAI, "0xdE42356c7d9e4B67F152ce638D343eA7A249556b"]])], [network_1.Network.Rinkeby, new Map([[Token.ETH, ETHER_TOKEN_ADDRESS], [Token.USDC, "0xD31B223205137361e742293B7d0dF594b4240D63"], [Token.DAI, "0x2599a5861bB8514e62964aD64Ed77375A44E2571"]])]]);
var addressToTokenMap = new Map(Array.from(tokenToAddressMap.entries()).map(function (kv) {
  return [kv[0], new Map(Array.from(kv[1].entries()).map(function (kv) {
    return [kv[1], kv[0]];
  }))];
}));

var TokenUtils =
/** @class */
function () {
  function TokenUtils() {}

  TokenUtils.getAddress = function (network, token) {
    if (!tokenToAddressMap.has(network)) {
      return null;
    }

    if (!tokenToAddressMap.get(network).has(token)) {
      return null;
    }

    return tokenToAddressMap.get(network).get(token);
  };

  TokenUtils.fromAddress = function (network, tokenAddress) {
    if (!addressToTokenMap.has(network)) {
      return null;
    }

    if (!addressToTokenMap.get(network).has(tokenAddress)) {
      return null;
    }

    return addressToTokenMap.get(network).get(tokenAddress);
  };

  TokenUtils.getSupportedTokens = function (network) {
    if (!addressToTokenMap.has(network)) {
      return [];
    }

    return Array.from(tokenToAddressMap.get(network).keys());
  };

  TokenUtils.isSupportedToken = function (network, token) {
    if (!tokenToAddressMap.has(network)) {
      return false;
    }

    return tokenToAddressMap.get(network).has(token);
  };

  return TokenUtils;
}();

exports.TokenUtils = TokenUtils;